import React, { useState } from "react";
import { Share2, Copy, Check } from "lucide-react";
import { toast } from "sonner";

// Native share button — uses the iPhone/Android share sheet when available,
// falls back to "Copy link" on desktop browsers without Web Share API.
export default function ShareButton({ title, excerpt, className = "", label = "Share this piece", url: overrideUrl, testId = "share-piece-btn" }) {
  const [copied, setCopied] = useState(false);

  const handleShare = async () => {
    const url = overrideUrl || (typeof window !== "undefined" ? window.location.href : "");
    // Pass ONLY the URL to iOS's Share Sheet so that "Copy" places a clean,
    // valid URL on the clipboard (no descriptive text prepended). Facebook,
    // Messages, iMessage, etc. will still render a rich preview from the
    // URL's embedded Open Graph tags (title, description, cover image).
    const shareData = { url };

    // Web Share API — opens iOS / Android native share sheet
    if (navigator.share) {
      try {
        await navigator.share(shareData);
        return;
      } catch (e) {
        // user cancelled — ignore
        if (e && e.name === "AbortError") return;
      }
    }

    // Fallback: copy the URL to the clipboard
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      toast.success("Link copied — paste it anywhere!");
      setTimeout(() => setCopied(false), 2500);
    } catch {
      toast.error("Couldn't copy automatically — long-press the address bar and choose Copy.");
    }
  };

  return (
    <button
      type="button"
      onClick={handleShare}
      data-testid={testId}
      className={
        className ||
        "inline-flex items-center gap-2 px-5 py-3 bg-ink text-paper text-xs tracking-[0.2em] uppercase hover:bg-terracotta transition-colors"
      }
    >
      {copied ? <Check size={14} /> : <Share2 size={14} />}
      {copied ? "Link copied" : label}
    </button>
  );
}
